import { commonValue, slowestStatus } from "./orderStatus";
import { formatOrderDate, formatOrderTime, parseDateTime } from "./format";

const latestTimestamp = (values) => {
  const times = values
    .map(parseDateTime)
    .filter(Boolean)
    .map((date) => date.getTime());

  return times.length ? new Date(Math.max(...times)) : null;
};

export const mergeTimelines = (subOrders) => {
  const timelines = subOrders
    .map((sub) => sub.timeline)
    .filter((timeline) => Array.isArray(timeline) && timeline.length);

  if (!timelines.length) return null;

  const template = timelines.reduce((longest, timeline) =>
    timeline.length > longest.length ? timeline : longest
  );

  return template.map((step) => {
    const matches = timelines.map((timeline) =>
      timeline.find((candidate) => candidate.step === step.step)
    );

    const completed = matches.every((match) => match?.completed);
    const occurredAt = completed
      ? latestTimestamp(matches.map((match) => match?.occurredAt))
      : null;

    return {
      ...step,
      completed,
      occurredAt,
      date: occurredAt ? formatOrderDate(occurredAt) : "",
      time: occurredAt ? formatOrderTime(occurredAt) : "",
      terminal: matches.some((match) => match?.terminal),
    };
  });
};

export const aggregateMaster = (subOrders) => {
  const loaded = (subOrders || []).filter(Boolean);

  if (!loaded.length) return null;

  return {
    status: slowestStatus(loaded.map((sub) => sub.status)),
    deliveryTypeLabel: commonValue(loaded.map((sub) => sub.deliveryTypeLabel)),
    deliveryTypeCode: commonValue(loaded.map((sub) => sub.deliveryTypeCode)),
    addressLabel: commonValue(loaded.map((sub) => sub.deliveryAddressLabel)),
    etaLabel: commonValue(loaded.map((sub) => sub.deliveryLabel)),
    scheduled: loaded.some((sub) => sub.scheduled),
    cancellable: loaded.filter((sub) => sub.cancellable),
    timeline: mergeTimelines(loaded),
  };
};
